"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURRENT_BRAND = exports.GENERIC_RESELLER_SLUG = void 0;
const utils_1 = require("../../utils");
exports.GENERIC_RESELLER_SLUG = utils_1.envConfig.genericUrl;
exports.CURRENT_BRAND = utils_1.envConfig.currentBrand;
